import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { Form } from "./Form";
import { ILegalTeamMast, Table } from "./Table";
import { EmptyLegalTeam, LegalTeamData, legalTeamData } from "./EmptyLegalTeam";
import { ILegalTeamManagement } from "../../models/LegalTeamManagment";
import { LegalTeamMembersForm } from "./LegalTeamMemberForm";
import { IPermissionProps } from "../../models/Login";
import { MoveLegalTeamMembersForm } from "./MoveLegalTeamMembersForm";

export interface IModel {
    open: boolean,
    singleData: ILegalTeamManagement,
    teamNameList: ILegalTeamMast[]
}

export interface IModel2 {
    open: boolean,
    singleData: legalTeamData
}

export interface IModel3 {
    open: boolean,
    singleData: legalTeamData[],
    inTeam: legalTeamData,
}

export const LegalTeamManagement = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyLegalTeam, open: false, teamNameList: [] } as IModel);
    const [modal2, setModal2] = useState({ singleData: LegalTeamData, open: false } as IModel2);
    const [modal3, setModal3] = useState({ singleData: [], open: false, inTeam: {} } as IModel3);
    const [reload, setReload] = useState(false);
    const [reload2, setReload2] = useState(false);
    const [reload3, setReload3] = useState(false);
    const toast = useRef<any>(null);
    const hideDialog = () => { setModal({ singleData: EmptyLegalTeam, open: false, teamNameList: [] }); };
    const hideDialog2 = () => { setModal2({ singleData: LegalTeamData, open: false  }); };
    const hideDialog3 = () => { setModal3({ singleData: [], open: false, inTeam: LegalTeamData }); };

    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} teamNameList={modal.teamNameList} />
            <LegalTeamMembersForm singleData={modal2.singleData} open={modal2.open} hideDialog={hideDialog2} toast={toast} reload={reload2} setReload={setReload2} setModal={setModal} setModal3={setModal3} />
            <MoveLegalTeamMembersForm singleData={modal3.singleData} open={modal3.open} hideDialog={hideDialog3} toast={toast} reload={reload3} setReload={setReload3} inTeam={modal3.inTeam} setModal={setModal2} />
            <Table permissions={permissions} setModal={setModal} setModal2={setModal2} toast={toast} reload={reload} setReload={setReload}  />
            <Toast ref={toast} />
        </>
    );
}
